module.exports = __webpack_public_path__ + "img/Bougie_de_decoration.f34017d.jpg";